export default class ShowPassword {
    constructor(options) {
        const _defaults = {
            showPasswordTrigger: ".js-show-password"
        }
        this.defaults = Object.assign({}, _defaults, options);
    }

    init() {
        this.getShowPasswordTrigger().on('click', function () {
            let input = $(this).parent('.input-field').find('input');
            if (input.is(':password')) {
                input.attr('type', 'text');
            } else {
                input.attr('type', 'password');
            }
        });
    }

    getShowPasswordTrigger() {
        return $(this.defaults.showPasswordTrigger);
    }
}


// WEBPACK FOOTER //
// ./static/js/components/ShowPassword.js